module.exports = __webpack_public_path__ + "img/Postmodernisme_Rune-Christiansen.049c278c.jpg";